var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");
'use strict';$CLJS.CI=new $CLJS.P(null,"s","s",1705939918);